module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/2-d56196f48f09ad1ab1c3429afdaf5e18.jpg";